export type HospitalInfoType = {
  hospitalOriginId?: number
  name: string
  fullAddress: string
  score?: number
  reviewCount?: number
  categoryName: string
}

export enum HospitalReviewSortEnum {
  LATEST = "LATEST",
  HIGH_SCORE = "HIGH_SCORE",
  LOW_SCORE = "LOW_SCORE",
}

export type TreatmentCaseSummaryResponse = {
  treatmentCaseId: number,
  treatmentSubjectName: string,
  title: string,
  thumbnail: {
    beforeImageUrl: string,
    afterImageUrl: string
  }
}

export type ReviewAnalysisResponse = {
  /** EVALUATION_STAT(평가 통계) | SELECTION_EVIDENCE(선택 근거). 기존 데이터는 항상 EVALUATION_STAT */
  categoryGroup?: string,
  majorCategory: string,
  items: {
    minorCategory: string,
    minorCount: number,
    minorPercent: number,
    /** 화면에 인용할 근거 리뷰 문장. 부정 항목에는 노출하지 않는다 */
    representativeQuote?: string
  }[]
}
